import React from 'react';
import StyledFooter from '../../../styled/Layout/StyledFooter';
import TopFooter from './TopFooter';
import BottomFooter from './BottomFooter';

const Footer = () => {
    return (
        <>
            <StyledFooter>
                <TopFooter />
            </StyledFooter>
            <BottomFooter />
        </>
    );
};

export default Footer;
